import { createRouter, createWebHistory } from "vue-router";
import store from '../store';
import Login from '@/views/LoginPage.vue';

const routes = [
  {
    path: "/login",
    name: 'Login',
    component: Login,
    meta: { role: ['sale','pm','admin'] },
  },
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/sale/dashboard',
    name: 'SaleDashboard',
    meta: { role: ['sale','admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'sale' || role === 'admin') {
            const component = (await import('@/views/sale/DashBoard.vue')).default;
            to.matched[0].components = { default: component };
            next();
          }else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/productmaster/dashboard',
    name: 'ProductMasterDashboard',
    meta: { role: ['sale','pm','admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin' || role === 'pm') {
            const component = (await import('@/views/productmaster/DashBoard.vue')).default;
            to.matched[0].components = { default: component };
            next();
          }else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: "/sale/creatematerial/:productNo?",
    name: 'SaleCreateMaterial',
    meta: { role: ['sale','admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'sale' || role === 'admin') {
            const component = (await import('@/views/sale/CreateMaterial.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: "/productmaster/creatematerial/:productNo?",
    name: 'ProductMasterCreateMaterial',
    meta: { role: ['pm','admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'pm' || role === 'admin') {
            const component = (await import('@/views/productmaster/CreateMaterial.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/productmaster/bomstruct',
    name: 'ProductMasterBomStruct',
    meta: { role: ['pm', 'admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'pm' || role === 'admin') {
            const component = (await import('@/views/productmaster/BomStruct.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: "/cs/searchproducts",
    name: "SearchProducts",
    meta: { role: ["cs", "admin"] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === "cs" || role === "admin") {
            const component = (await import("@/views/cs/SearchProducts.vue")).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next("/404");
          }
        } catch (error) {
          next("/404");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/cs/createorder",
    name: "CreateOrder",
    meta: { role: ["cs", "admin"] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === "cs" || role === "admin") {
            const component = (await import("@/views/cs/CreateOrder.vue")).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next("/404");
          }
        } catch (error) {
          next("/404");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/cs/createorder/bulk",
    name: "CreateOrderBulk",
    meta: { role: ["cs", "admin"] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === "cs" || role === "admin") {
            const component = (await import("@/views/cs/CreateOrderBulk.vue")).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next("/404");
          }
        } catch (error) {
          next("/404");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/cs/changeorder",
    name: "ChangeOrder",
    meta: { role: ["cs", "admin"] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === "cs" || role === "admin") {
            const component = (await import("@/views/cs/ChangeOrder.vue")).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next("/404");
          }
        } catch (error) {
          next("/404");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/cs/pricing",
    name: "Pricing",
    meta: { role: ["cs", "admin"] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === "cs" || role === "admin") {
            const component = (await import("@/views/cs/ProductPricing.vue")).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next("/404");
          }
        } catch (error) {
          next("/404");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    // TASK-047 — รายการ SO ติดวงเงิน (admin only) — วางต่อจาก Pricing ในแถบเมนู
    path: "/configuration/creditblockedorders",
    name: "CreditBlockedOrders",
    meta: { role: ["admin"] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === "admin") {
            const component = (await import("@/views/configuration/ManageCreditBlockedOrders.vue")).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next("/404");
          }
        } catch (error) {
          next("/404");
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/cs/sheetboardordering",
    name: "SheetBoardOrdering",
    meta: { role: ["cs", "admin"] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === "cs" || role === "admin") {
            const component = (await import("@/views/cs/SheetBoardOrdering.vue")).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next("/404");
          }
        } catch (error) {
          next("/404");
        }
      } else {
        next("/login");
      }
    }
  },
  //configuration for master
  {
    path: '/configuration/customer',
    name: 'ConfigurationCustomer',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/ManageCustomer.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/color',
    name: 'ConfigurationColor',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/ManageColor.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/plant',
    name: 'ConfigurationPlant',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/ManagePlant.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/board',
    name: 'ConfigurationBoard',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/ManageBoard.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/papergrade',
    name: 'ConfigurationPaperGrade',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/ManagePaperGrade.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/flute',
    name: 'ConfigurationFlute',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/ManageFlute.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/machine',
    name: 'ConfigurationMachine',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/ManageMachine.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/users',
    name: 'ConfigurationUsers',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/ManageUser.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/menuaccess',
    name: 'ConfigurationMenuAccess',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/MenuAccessMatrix.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/configuration/rawmaterialmaster',
    name: 'ConfigurationRawMaterialMaster',
    meta: { role: ['admin'] },
    beforeEnter: async (to, from, next) => {
      if (store.getters.isAuthenticated) {
        const role = store.getters.role;
        try {
          if (role === 'admin') {
            const component = (await import('@/views/configuration/RawMaterialMaster.vue')).default;
            to.matched[0].components = { default: component };
            next();
          } else {
            next('/404');
          }
        } catch (error) {
          next('/404');
        }
      } else {
        next('/login');
      }
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: { anonymous: true },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
    meta: { anonymous: true },
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/PageNotFound.vue'),
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: () => import('@/views/PageForbidden.vue'),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  linkActiveClass: "active",
});

const ANONYMOUS_PATHS = ['/login', '/forgot-password', '/reset-password'];

router.beforeResolve(async (to, from, next) => {
  try {
    const isAuthenticated = store.getters.isAuthenticated;
    const role = store.getters.role;
    const isAnonymousRoute = ANONYMOUS_PATHS.includes(to.path) || to.meta?.anonymous;
    if (!isAuthenticated && !isAnonymousRoute) {
      next({ path: "/login" });
    } else if (isAuthenticated && to.path === "/login") {
      if (role === "pm") {
        next({ path: "/productmaster/dashboard" });
      } else if (role === "sale" || role === "admin") {
        next({ path: "/sale/dashboard" });
      } else if (role === "cs") {
        next({ path: "/cs/searchproducts" }); // เพิ่ม redirect ให้ cs
      } else {
        next({ path: "/404" });
      }
    } else {
      next();
    }
  } catch (error) {
    next("/404");
  }
});

export default router;
